import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
  const [form, setForm] = useState({ bkash_number: "", nagad_number: "", rocket_number: "", instructions: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => {
      setForm({
        bkash_number: data.bkash_number || "",
        nagad_number: data.nagad_number || "",
        rocket_number: data.rocket_number || "",
        instructions: data.instructions || "",
      });
      setLoading(false);
    });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("Settings saved");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-sm text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Payment numbers shown to users when purchasing.</p>
      </div>

      <div className="glass-card rounded-lg p-6 space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider">bKash Number</Label>
            <Input data-testid="bkash-number" placeholder="01XXXXXXXXX" value={form.bkash_number} onChange={(e) => setForm({ ...form, bkash_number: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider">Nagad Number</Label>
            <Input data-testid="nagad-number" placeholder="01XXXXXXXXX" value={form.nagad_number} onChange={(e) => setForm({ ...form, nagad_number: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider">Rocket Number</Label>
            <Input data-testid="rocket-number" placeholder="01XXXXXXXXX" value={form.rocket_number} onChange={(e) => setForm({ ...form, rocket_number: e.target.value })} />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider">Payment Instructions</Label>
          <Textarea
            data-testid="payment-instructions"
            rows={3}
            placeholder="e.g. Send Money kore TXN ID submit korun…"
            value={form.instructions}
            onChange={(e) => setForm({ ...form, instructions: e.target.value })}
          />
        </div>
        <Button onClick={save} disabled={saving} data-testid="save-settings">
          <Save className="w-4 h-4 mr-2" />
          {saving ? "Saving…" : "Save"}
        </Button>
      </div>
    </div>
  );
}
